import {NOTIFICATION_TITLES} from '@/utils/constants/commonConstants';

const DEFAULT_NOTIFICATION_PROPS = {
  show: true,
  arrowButton: true
};

export const NOTIFICATION_CONFIGS = {
  error: {
    type: 'error',
    message: {
      title: NOTIFICATION_TITLES.ERROR_UPLOADING_REWARD_LIST,
      subTitle: NOTIFICATION_TITLES.UPLOAD_FAILED_SUBTITLE
    },
    ...DEFAULT_NOTIFICATION_PROPS,
    iconType: 'error_outline'
  },
  info: {
    type: 'info',
    message: {
      title: NOTIFICATION_TITLES.UPLOADING_REWARD_LIST,
      subTitle: NOTIFICATION_TITLES.UPLOADING_SUBTITLE
    },
    ...DEFAULT_NOTIFICATION_PROPS,
    iconType: 'error_outline'
  },
  success: {
    type: 'success',
    message: {
      title: NOTIFICATION_TITLES.REWARDS_LIST_SUCCESSFULLY_PUBLISHED
    },
    ...DEFAULT_NOTIFICATION_PROPS,
    buttonShow: true,
    iconType: 'check_circle_outline'
  }
};

export const getNotificationConfig = (notificationState = 'info') => {
  return NOTIFICATION_CONFIGS[notificationState];
};
